import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/vuex/index';
import i18n from '@/js/i18n/i18n';
import setupInterceptors from './js/services/setupInterceptors';
setupInterceptors(store);

// A tab opened before a deploy still runs the old build: its lazy chunks are
// gone from the server (404), so the next route or async component fails to
// load and the page renders half-empty (seen 2026-10-24: property page
// without description and buttons). Reload once to pick up the new build;
// index.html is served no-cache. The timestamp guard stops a reload loop if
// a chunk is genuinely broken.
const RELOAD_KEY = 'chunk_reload_at';
const isChunkError = (err) =>
  !!err &&
  (err.name === 'ChunkLoadError' ||
    err.code === 'CSS_CHUNK_LOAD_FAILED' ||
    /Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module/i.test(
      err.message || ''
    ));
const reloadForNewBuild = (path) => {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
  } catch (e) {
    // storage unavailable: reload anyway, the browser caps nothing here
  }
  if (Date.now() - last < 10000) return false;
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (e) {
    return false; // without the guard a broken chunk could loop forever
  }
  if (path) window.location.assign(path);
  else window.location.reload();
  return true;
};

router.onError((err, to) => {
  if (isChunkError(err)) reloadForNewBuild(to?.fullPath);
});
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkError(e.reason)) reloadForNewBuild();
});

const app = createApp(App);
app.config.errorHandler = (err, instance, info) => {
  if (isChunkError(err) && reloadForNewBuild()) return;
  console.error(err, info);
};
app.use(i18n).use(store).use(router).mount('#app');
